import React, { useEffect, useState } from 'react';
import MultiSelectAsyncV2 from '../MultiSelectAsyncV2';
import BaseService from 'services/BaseService';

const NsirSelectV2 = ({ onSelect, value, isRequired, error, helperText, disabled, label = "Nsirs" }) => {
  const [selectedObjects, setSelectedObjects] = useState([]);
  const [loadingInitial, setLoadingInitial] = useState(false);

  useEffect(() => {
    const hydrateValues = async () => {
      if (value && Array.isArray(value) && value.length > 0 && typeof value[0] !== 'object') {
        setLoadingInitial(true);
        try {
          const params = new URLSearchParams();
          params.append('nsirIds', value.join(','));
          const response = await BaseService.get({ url: `nsirs/options/ids?${params.toString()}` });
          const formatted = response.data.map(o => ({ value: o.id, label: o.label }));
          setSelectedObjects(formatted);
        } catch (e) {
          console.error("Erro ao hidratar valores iniciais:", e);
        } finally {
          setLoadingInitial(false);
        }
      } else if (!value || value.length === 0) {
        setSelectedObjects([]);
      }
    };
    hydrateValues();
  }, [value]);

  const loadOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];
    try {
      const params = new URLSearchParams();
      params.append('search', inputValue);
      const response = await BaseService.get({ url: `nsirs/options?${params.toString()}` });
      return response.data.map(o => ({ value: o.id, label: o.label }));
    } catch (e) {
      console.error("Erro na busca assíncrona:", e);
      return [];
    }
  };

  return (
    <MultiSelectAsyncV2
      label={label} error={error} helperText={helperText}
      isRequired={isRequired} disabled={disabled || loadingInitial}
      loadOptions={loadOptions} value={selectedObjects}
      placeholder={loadingInitial ? "Carregando..." : "Digite para buscar (ex: 001...)"}
      onChange={selected => {
        setSelectedObjects(selected || []);
        const ids = selected ? selected.map(v => v.value) : null;
        const labels = selected ? selected.map(v => v.label) : null;
        onSelect(ids, labels);
      }}
    />
  );
};

export default NsirSelectV2;
